import { TPricesState, TRootState } from '../../types'
import { createSelector } from '@reduxjs/toolkit'
import { pricesAdapter } from './adapter'

const selectState = (state: TRootState): TPricesState => state.prices

const adapterSelectors =pricesAdapter.getSelectors(selectState)

const fetchStatus = createSelector(
    selectState,
    (state) => ({
        isFetching: state.isFetching,
        error: state.fetchError,
    })
)

const totalItems = createSelector(
    selectState,
    (state) => (state.totalItems)
)


export const selectors = {
    ...adapterSelectors,
    fetchStatus,
    totalItems,
}